import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

const PageTitle = props => (
  <div className="col-md-12">
    {
      <div className="pull-right page-title">
        <Link to={`/pending-products/${props.prevId}`}>
          <button
            type="button"
            className="btn green"
            style={{ marginRight: '10px' }}
            disabled={!props.prevId}
          >
            Previous
          </button>
        </Link>

        <Link to={`/pending-products/${props.nextId}`}>
          <button
            type="button"
            className="btn green"
            disabled={!props.nextId}
          >
            Next
          </button>
        </Link>
      </div>
    }
  </div>
)

PageTitle.propTypes = {
  prevId: PropTypes.string.isRequired,
  nextId: PropTypes.string.isRequired,
}

export default PageTitle
